module.exports = __webpack_public_path__ + "img/comment.3cb3776d.svg";